function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";
import { Radio, Form, Button, Checkbox, Input, message, Select, Alert, Space, Col as AntCol, Row as AntRow } from 'antd';
import { Container, Col, Row } from "react-bootstrap";
import Common from "../includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var NewGlassPrescription = function NewGlassPrescription(_ref) {
  var _ref$patient = _ref.patient,
      patient = _ref$patient === void 0 ? null : _ref$patient,
      _ref$check = _ref.check,
      check = _ref$check === void 0 ? null : _ref$check,
      handler = _ref.handler;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      drugsOptions = _useState2[0],
      setDrugsOptions = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      deptOptions = _useState4[0],
      setDeptOptions = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      deptData = _useState6[0],
      setDeptData = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isFormProcessing = _useState8[0],
      setIsFormProcessing = _useState8[1];

  var _useState9 = useState(""),
      _useState10 = _slicedToArray(_useState9, 2),
      errorMessage = _useState10[0],
      setErrorMessage = _useState10[1];

  var _useState11 = useState(""),
      _useState12 = _slicedToArray(_useState11, 2),
      successMessage = _useState12[0],
      setSuccessMessage = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      itemsData = _useState14[0],
      setItemsData = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      itemsOptionsData = _useState16[0],
      setItemsOptionsData = _useState16[1];

  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setErrorMessage("");
    setSuccessMessage("");
    var formData = new FormData();
    formData.append("bilan", values.bilan);
    if (check == null) formData.append("medical_check_id", null);else formData.append("medical_check_id", check.id);
    formData.append("user_id", Common.currentUser.id);
    formData.append("dcode", "LUN");
    formData.append("axe_g", values.axe_g);
    formData.append("sphere_g", values.sphere_g);
    formData.append("cylindre_g", values.cylindre_g);
    formData.append("addition_g", values.addition_g);
    formData.append("axe_d", values.axe_g);
    formData.append("sphere_d", values.sphere_g);
    formData.append("cylindre_d", values.cylindre_g);
    formData.append("addition_d", values.addition_g);
    formData.append("ep", values.ep);
    axios.post(Common.baseApiUrl + "setbilan", formData).then(function (response) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      if (response.data.status == 200) {
        handler();
        setSuccessMessage("Bilan(s) prescrit avec succès");
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };

  var handleDeptChange = function handleDeptChange(e) {
    setItemsOptionsData([]);
    var ar = deptData.filter(function (d) {
      return d.id.toString() == e.target.value;
    });

    if (ar.length > 0) {
      ar.forEach(function (d) {
        d.services.forEach(function (s) {
          setItemsOptionsData(function (prev) {
            return [].concat(_toConsumableArray(prev), [s]);
          });
        });
      });
    }
  };

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getservicetree').then(function (response) {
      if (response.data.status == 200) {
        var ars = response.data.services.filter(function (d) {
          return d.type == 2 && d.dcode == 'LUN';
        });
        ars.forEach(function (d) {
          setItemsData(function (prev) {
            return [].concat(_toConsumableArray(prev), [d]);
          });
          d.medical_items.forEach(function (m_i) {
            setDrugsOptions(function (prev) {
              return [].concat(_toConsumableArray(prev), [{
                label: m_i.label,
                value: m_i.id
              }]);
            });
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "horizontal",
      form: form,
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "department",
        children: /*#__PURE__*/_jsx(Radio.Group, {
          onChange: handleDeptChange,
          options: deptOptions,
          optionType: "button",
          buttonStyle: "solid"
        })
      }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
        type: "error",
        message: errorMessage,
        banner: true
      }), successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
        type: "success",
        message: successMessage,
        banner: true
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "bilan",
        rules: [{
          required: true,
          message: "Veuillez choisir une option"
        }],
        children: /*#__PURE__*/_jsx(Select, {
          mode: "multiple",
          size: "large",
          filterOption: true,
          optionFilterProp: "label",
          placeholder: "Choisir les produits",
          style: {
            width: '100%'
          },
          options: drugsOptions
        })
      }), /*#__PURE__*/_jsxs("fieldset", {
        children: [/*#__PURE__*/_jsx("legend", {
          children: "Oeil Droit"
        }), /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              sm: 6,
              children: /*#__PURE__*/_jsx(Form.Item, {
                label: "SPHERE",
                name: "sphere_d",
                children: /*#__PURE__*/_jsx(Input, {})
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              sm: 6,
              children: /*#__PURE__*/_jsx(Form.Item, {
                label: "CYLINDRE",
                name: "cylindre_d",
                children: /*#__PURE__*/_jsx(Input, {})
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              sm: 6,
              children: /*#__PURE__*/_jsx(Form.Item, {
                label: "AXE",
                name: "axe_d",
                children: /*#__PURE__*/_jsx(Input, {})
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              sm: 6,
              children: /*#__PURE__*/_jsx(Form.Item, {
                label: "ADDITION",
                name: "addition_d",
                children: /*#__PURE__*/_jsx(Input, {})
              })
            })]
          })
        })]
      }), /*#__PURE__*/_jsxs("fieldset", {
        children: [/*#__PURE__*/_jsx("legend", {
          children: "Oeil Gauche"
        }), /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              sm: 6,
              children: /*#__PURE__*/_jsx(Form.Item, {
                label: "SPHERE",
                name: "sphere_g",
                children: /*#__PURE__*/_jsx(Input, {})
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              sm: 6,
              children: /*#__PURE__*/_jsx(Form.Item, {
                label: "CYLINDRE",
                name: "cylindre_g",
                children: /*#__PURE__*/_jsx(Input, {})
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              sm: 6,
              children: /*#__PURE__*/_jsx(Form.Item, {
                label: "AXE",
                name: "axe_g",
                children: /*#__PURE__*/_jsx(Input, {})
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              md: 3,
              sm: 6,
              children: /*#__PURE__*/_jsx(Form.Item, {
                label: "ADDITION",
                name: "addition_g",
                children: /*#__PURE__*/_jsx(Input, {})
              })
            })]
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "ep",
        label: "EP",
        children: /*#__PURE__*/_jsx(Input, {
          suffix: "mm"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disabled: drugsOptions.length == 0,
          htmlType: "submit",
          type: "primary",
          children: "Prescrire"
        })
      })]
    })
  });
};

export default NewGlassPrescription;